module.exports = __webpack_public_path__ + "static/media/messages.680d88be.svg";